module.exports = __webpack_public_path__ + "static/img/p3.76254432.jpg";